import { PricingRow, RuleRow } from "./Updatebuilderschema";


export const buildRuleString = (completedRows: RuleRow[]): string => {
    if (completedRows.length === 0) return "";

    let ruleString = "";

    completedRows.forEach((row, index) => {
        const parts = [];

        if (index === 0) {
            parts.push(row.condition || "If");
        }

        if (row.groupStart) {
            parts.push(row.groupStart);
        }

        if (row.dataType && row.attribute) {
            parts.push(`${row.dataType}.${row.attribute}`);
        } else if (row.dataType) {
            parts.push(row.dataType);
        }

        if (row.operator) {
            parts.push(row.operator);
        }

        if (row.operand2Type === "value") {
            if (row.operand2) {
                parts.push(row.operand2);
            }
        } else {
            if (row.dataType2 && row.attribute2) {
                parts.push(`${row.dataType2}.${row.attribute2}`);
            } else if (row.dataType2) {
                parts.push(row.dataType2);
            }
        }

        if (row.groupEnd) {
            parts.push(row.groupEnd);
        }

        if (row.connector && index < completedRows.length - 1) {
            parts.push(row.connector);
        }

        if (parts.length > 0) {
            const joined = parts.join("");
            if (ruleString.length > 0) {
                ruleString += "  " + joined + "\n";
            } else {
                ruleString += joined + "\n";
            }
        }
    });
    console.log("ruleString", ruleString.trim())
    return ruleString.trim();
};

// pricing adjustment string
export const buildPricingString = (completedPricingRows: PricingRow[]): string => {
    if (completedPricingRows.length === 0) return "";

    let pricingString = "";

    completedPricingRows.forEach((pricingRow) => {
        const pricingParts = [];

        if (pricingRow.dataType && pricingRow.attribute) {
            pricingParts.push(`${pricingRow.dataType}.${pricingRow.attribute}`);
        } else if (pricingRow.dataType) {
            pricingParts.push(pricingRow.dataType);
        }

        if (pricingRow.dataType && pricingRow.attribute) {
            pricingParts.push(pricingRow.operator || "=");
        }

        if (pricingRow.expressionType === "value") {
            if (pricingRow.expressionValue) {
                pricingParts.push(pricingRow.expressionValue);
            }
        } else if (pricingRow.expressionType === "operand") {
            if (pricingRow.dataType2 && pricingRow.attribute2) {
                pricingParts.push(`${pricingRow.dataType2}.${pricingRow.attribute2}`);
            } else if (pricingRow.dataType2) {
                pricingParts.push(pricingRow.dataType2);
            }
        }

        if (pricingParts.length > 0) {
            pricingString += pricingParts.join("") + ";\n";
        }
    });

    return pricingString.trim();
};

// ai adjustment string
export const buildPricingStringFormatted = (
    completedPricingRows: PricingRow[]
): string => {
    if (completedPricingRows.length === 0) return "";

    let pricingString = "";

    completedPricingRows.forEach((pricingRow) => {
        const parts = [];

        if (pricingRow.dataType && pricingRow.attribute) {
            parts.push(`#${pricingRow.dataType}#.[${pricingRow.attribute}]`);
        } else if (pricingRow.dataType) {
            parts.push(`#${pricingRow.dataType}#`);
        }

        if (pricingRow.dataType && pricingRow.attribute) {
            parts.push(pricingRow.operator || "=");
        }

        if (pricingRow.expressionType === "value") {
            if (pricingRow.expressionValue) {
                parts.push(pricingRow.expressionValue);
            }
        } else if (pricingRow.expressionType === "operand") {
            if (pricingRow.dataType2 && pricingRow.attribute2) {
                parts.push(`#${pricingRow.dataType2}#.[${pricingRow.attribute2}]`);
            } else if (pricingRow.dataType2) {
                parts.push(`#${pricingRow.dataType2}#`);
            }
        }

        if (parts.length > 0) {
            pricingString += parts.join("") + ";\n    ";
        }
    });

    return pricingString.trim();
};

export const buildFinalRule = (
    ruleString: string,
    pricingString: string
): string => {
    const rule = ruleString?.trim() || "";
    const pricing = pricingString?.trim() || "";

    if (!rule && !pricing) return "";

    // Wrap rule inside extra parentheses
    const wrappedRule = `(${rule}\n)`;

    let final = wrappedRule + "\n";

    final += "{\n";

    if (pricing) {
        const indentedPricing = pricing
            .split("\n")
            .map((line) => "    " + line)
            .join("\n");

        final += indentedPricing + "\n";
    }

    final += "}EndIf";

    return final;
};
